import { ICoordinate } from "types";

export const validCoordinate = (coordinate: ICoordinate) => {
  return coordinate.x >= 0 || coordinate.y >= 0;
};
